import { FC } from 'react'
import { SocialMediaProps } from './interfaces'

const Facebook: FC<SocialMediaProps> = ({
  width = 20,
  height = 20,
  color = 'white',
}) => {
  const fillColor = {
    white: '#FFFFFF',
    'grey-500': '#75787B',
    black: '#212721',
  }
  const DEFAULT_COLOR = fillColor.white

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6381 9.55809C18.6381 4.2793 14.4658 0 9.31905 0C4.17228 0 0 4.2793 0 9.55809C0 14.3288 3.40784 18.283 7.86295 19V12.321H5.49678V9.55809H7.86295V7.45232C7.86295 5.05683 9.25421 3.73363 11.3829 3.73363C12.4025 3.73363 13.4689 3.92031 13.4689 3.92031V6.27249H12.2938C11.1362 6.27249 10.7751 7.00927 10.7751 7.76514V9.55809H13.3597L12.9466 12.321H10.7751V19C15.2303 18.283 18.6381 14.3288 18.6381 9.55809Z"
        fill={fillColor[color] || DEFAULT_COLOR}
      />
    </svg>
  )
}

export default Facebook
